module.exports = __webpack_public_path__ + "img/d_v5.1c46b2d.png";